import { useMemo } from "react";

export const usePagination = <T>(
  items: T[],
  page: number,
  perPage: number
) => {
  return useMemo(() => {
    const total = items.length;
    const totalPages = Math.max(1, Math.ceil(total / perPage));
    const safePage = Math.min(page, totalPages);

    const startIndex = (safePage - 1) * perPage;
    const endIndex = Math.min(startIndex + perPage, total);

    return {
      total,
      totalPages,
      startIndex,
      endIndex,
      pageItems: items.slice(startIndex, endIndex),
    };
  }, [items, page, perPage]);
};